import qs from 'query-string';
import React from 'react';
import { useParams } from 'react-router-dom';
import { eventService } from 'library/api/eventService';
import type { TicketDetail } from 'library/models/events';

export const useTickets = () => {
  const { id } = useParams<{ id: string }>();
  const [count, setCount] = React.useState<number>(0);
  const [tickets, setTickets] = React.useState<TicketDetail[]>([]);

  React.useEffect(() => {
    const getTickets = async () => {
      try {
        const params = qs.stringify({ event: id });
        const response = await eventService.getTickets(params);
        setTickets(response.data.results);
        setCount(response.data.count);
      } catch (error) {
        throw error;
      }
    };

    getTickets();
  }, [id]);

  return {
    tickets,
    count,
  };
};
